import { render, staticRenderFns } from "./process-initiation.vue?vue&type=template&id=a05455cc"
import script from "./process-initiation.vue?vue&type=script&lang=js"
export * from "./process-initiation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports